import React from 'react';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import Label from './Label';
import CircledIcon from '../CircledIcon';

const LabelDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Labels</h4>
        <Row>
          <Col className="mt-10 pl-10">
            <Label>Label without icons</Label>
            <Label leftIcon={light('circle-exclamation')}>
              Label with left icon
            </Label>
            <Label rightIcon={light('circle-question')}>
              Label with right icon
            </Label>
            <Label
              rightIcon={light('circle-question')}
              leftIcon={light('circle-exclamation')}
            >
              Label with left and right icon
            </Label>
            <Label statusDot="orange">Label with status dot</Label>
            <Label>
              <CircledIcon
                iconClassName="icon-left"
                size="icon-sm"
                icon={light('circle-exclamation')}
              />
              Label with Circled Icon component
            </Label>
            <Label
              rightIcon={light('circle-question')}
              tooltip={
                <>
                  <div>Text1</div>
                  <div>Text2</div>
                </>
              }
              tooltipPos={'right'}
            >
              Label with right icon and tooltip
            </Label>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default LabelDemo;
